import styled from 'styled-components';

const FormContainer = styled.div`
  padding: 16px;
  font-size: 16px;
`;

export default FormContainer;
